// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PreviousOrdersDropdown_previous-orders-dropdown__hXB3Z {
  margin-bottom: 10.5rem;
  position: relative;
  width: max-content;
}

.PreviousOrdersDropdown_previous-orders-dropdown__btn__VMqJS {
  padding: 1.6rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  color: #000;
  font-size: var(--text-base);
  font-weight: 500;
  border-radius: 1rem;
  background-color: var(--gray-extra-light);
}

.PreviousOrdersDropdown_previous-orders-dropdown__arrow__OL3nE {
  width: 1.2rem;
  height: 1.2rem;
}

.PreviousOrdersDropdown_previous-orders-dropdown__menu__K51r0 {
  position: absolute;
  top: 5.7rem;
  right: 0;
  min-width: 100%;
  width: max-content;
  border-radius: 0px 0px 1rem 1rem;
  border: 1px solid var(--black-ten-opacity);
  background-color: #fff;
}

.PreviousOrdersDropdown_previous-orders-dropdown__menu-item__ED7YG {
  padding: 2.6rem;
  color: #000;
  font-size: var(--text-base);
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/components/Profile/PreviousOrders/PreviousOrdersDropdown/PreviousOrdersDropdown.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB","sourcesContent":[".previous-orders-dropdown {\n  margin-bottom: 10.5rem;\n  position: relative;\n  width: max-content;\n}\n\n.previous-orders-dropdown__btn {\n  padding: 1.6rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  color: #000;\n  font-size: var(--text-base);\n  font-weight: 500;\n  border-radius: 1rem;\n  background-color: var(--gray-extra-light);\n}\n\n.previous-orders-dropdown__arrow {\n  width: 1.2rem;\n  height: 1.2rem;\n}\n\n.previous-orders-dropdown__menu {\n  position: absolute;\n  top: 5.7rem;\n  right: 0;\n  min-width: 100%;\n  width: max-content;\n  border-radius: 0px 0px 1rem 1rem;\n  border: 1px solid var(--black-ten-opacity);\n  background-color: #fff;\n}\n\n.previous-orders-dropdown__menu-item {\n  padding: 2.6rem;\n  color: #000;\n  font-size: var(--text-base);\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previous-orders-dropdown": `PreviousOrdersDropdown_previous-orders-dropdown__hXB3Z`,
	"previous-orders-dropdown__btn": `PreviousOrdersDropdown_previous-orders-dropdown__btn__VMqJS`,
	"previous-orders-dropdown__arrow": `PreviousOrdersDropdown_previous-orders-dropdown__arrow__OL3nE`,
	"previous-orders-dropdown__menu": `PreviousOrdersDropdown_previous-orders-dropdown__menu__K51r0`,
	"previous-orders-dropdown__menu-item": `PreviousOrdersDropdown_previous-orders-dropdown__menu-item__ED7YG`
};
export default ___CSS_LOADER_EXPORT___;
